<template>
  <div class="content">
    <div class="center">
      <div class="image">
        <img :src="imgUrl" alt="" v-if="imgUrl">
        <div class="image-div" v-else>暂无图片</div>
      </div>
      <div>
        <div class="title">淘宝下单识别</div>
        <div class="upload">
          <el-upload
            class="upload-demo"
            drag
            :action="action"
            multiple
            :headers="headers"
            :on-success="uploadSuccess"
            :on-progress="uploadBegin"
            :before-upload="beforeUpload"
            :show-file-list="false"
            :multiple="false">
            <i class="el-icon-upload"></i>
            <div class="upload-text">将图片拖之框内或者<span>点击添加</span></div>
          </el-upload>
        </div>
        <div class="title" style="margin-top: 20px">识别信息</div>
        <div class="message">
          <div class="message-flex">
            <div class="message-text">城市：</div>
            <input class="input" type="text" placeholder="请输入城市名称如:厦门" v-model="movieInfo.city">
          </div>
          <div class="message-flex">
            <div class="message-text">影院信息：</div>
            <!--              <input type="text" v-model="movieInfo.cinemaName">-->
            <el-autocomplete
              v-model="movieInfo.cinemaName"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              @select="handleSelect"
              value-key="cinemaName"
            ></el-autocomplete>
          </div>
          <div class="message-flex">
            <div class="message-text">影片：</div>
            <input class="input" type="text" v-model="movieInfo.movieName">
          </div>
          <div class="message-flex">
            <div class="message-text">放映时间：</div>
            <input class="input" type="text" v-model="movieInfo.showTime" @blur="getOpeningTime">
          </div>
          <div class="message-flex">
            <div class="message-text">距离开场时间：</div>
            <div class="message-span" style="color: red">{{ openingTime }}</div>
          </div>
          <div class="message-flex">
            <div class="message-text">座位：</div>
            <input class="input" type="text" v-model="movieInfo.seatName"><span style="margin-left: 10px">(多个座位用逗号隔开)</span>
          </div>
          <div class="message-flex">
            <div class="message-text">数量：</div>
<!--            <input class="input" type="text" v-model="seatListLength">-->
            <div class="message-content">{{ seatListLength }}</div>
          </div>
          <div class="message-flex">
            <div class="message-text">全部信息：</div>
            <div class="message-content">{{ movieInfo.content }}</div>
          </div>
          <div class="message-flex">
            <div class="message-text">是否接受调座：</div>
            <el-radio-group v-model="isAllowChangeSeats" style="margin-left: 20px">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div class="message-flex">
            <div class="message-text">最高限价：</div>
            <input class="input" type="number" v-model="movieInfo.maxLimitPrice">元/张
            <!--            <div class="message-span colorRed" v-if="orderInfo.schedulePrice != ''">{{ orderInfo.schedulePrice }}/张</div>-->
<!--            <span-->
<!--              v-if="orderInfo.schedulePrice != ''"-->
<!--              v-clipboard:copy="orderInfo.schedulePrice + '元/张'"-->
<!--              v-clipboard:success="onCopy"-->
<!--              v-clipboard:error="onError" class="copyButton">复制</span>-->
          </div>
        </div>
      </div>
    </div>
    <!--    报价弹窗-->
    <el-dialog
      title="获取报价成功"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div>
        <div class="message-flex">
          <div class="message-text">建议报价：</div>
          <!--              <input class="input" type="text" v-model="orderInfo.schedulePrice">元/张-->
          <div class="message-span colorRed" v-if="orderInfo.schedulePrice != ''">{{ orderInfo.schedulePrice }}/张</div>
          <span
            v-if="orderInfo.schedulePrice != ''"
            v-clipboard:copy="orderInfo.schedulePrice + '元/张'"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError" class="copyButton">复制</span>
        </div>
        <div class="message-flex">
          <div class="message-text">备注内容：</div>
          <div class="message-span colorRed">{{ orderInfo.orderId }} <span
            v-if="orderInfo.orderId != ''"
            v-clipboard:copy="orderInfo.orderId"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError">复制</span></div>
        </div>
        <div class="message-flex">
          <div class="message-text">重要：</div>
          <div class="message-span colorRed">请将该备注内容复制到淘宝邀单的订单备注里</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
<!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <div class="button" style="background: #3D9EFC" :class="isUpload?'active-button':''" @click="getPrice">获取报价
    </div>
  </div>
</template>

<script>
import {getToken} from "../../../utils/auth";
import pay from "../../../javaApi/pay";

const PayM = new pay()
let loading = null
export default {
  name: "index",
  data() {
    return {
      // 备注
      remark: '',
      price: '', // 报价价格
      // 请求头
      headers: {
        OPENTOKEN: '',
      },
      // 图片上传地址
      action: process.env.VUE_APP_PROXY_TARGET_JAVA + 'api/movie-taobao/ocr-pic',
      movieInfo: {
        city: '',
        cinemaName: '',
        movieName: '',
        showTime: '',
        seatName: '',
        maxLimitPrice:'',
        isAllowChangeSeats:'',
      }, // 影院信息
      orderInfo: {
        schedulePrice: '',
        orderId: '',
      },
      isAllowChangeSeats:1,
      isUpload: false,
      imgUrl: '', //上传图片地址
      openingTime: '', // 开场时间
      minute: '', // 距离开场还有几分钟
      dialogVisible:false // 弹窗
    }
  },
  mounted() {
    this.headers.OPENTOKEN = getToken()
  },
  computed: {
    seatListLength: {
      get() {
        if (this.movieInfo.seatName != '') {
          let list = this.movieInfo.seatName.split(',')
          return list.length
        } else {
          return ''
        }
      }
    }
  },
  methods: {
    //复制
    onCopy: function (e) {
      this.$Message.success('复制成功');
    },
    onError: function (e) {
      this.$Message.success('复制失败');
    },
    uploadSuccess(response, file, fileList) {
      this.movieInfo = response.data
      // 计算时间
      let time, showTime
      showTime = this.movieInfo.showTime
      time = this.formatTime(new Date())
      let hour = this.GetDateDiff(time, showTime, 'minute') / 60
      let minute = this.GetDateDiff(time, showTime, 'minute')
      let timeArr = hour.toFixed(2).split('.')
      this.minute = minute
      this.openingTime = timeArr[0] + '小时' + (timeArr[1] * 60 / 100).toFixed(0) + '分钟'
      loading.close();
    },
    GetDateDiff(startTime, endTime, diffType) {
      //将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式
      startTime = startTime.replace(/\-/g, "/");
      endTime = endTime.replace(/\-/g, "/");
      //将计算间隔类性字符转换为小写
      diffType = diffType.toLowerCase();
      let sTime = new Date(startTime); //开始时间
      let eTime = new Date(endTime); //结束时间
      //作为除数的数字
      let timeType = 1;
      switch (diffType) {
        case"second":
          timeType = 1000;
          break;
        case"minute":
          timeType = 1000 * 60;
          break;
        case"hour":
          timeType = 1000 * 3600;
          break;
        case"day":
          timeType = 1000 * 3600 * 24;
          break;
        default:
          break;
      }
      return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
    },
    // 时间格式转换
    formatTime(time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    },
    beforeUpload(file) {
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        // 图片base64化
        var newUrl = this.result;    //图片路径
        _this.imgUrl = newUrl;
      };
      _this.orderInfo.schedulePrice = ''
      _this.orderInfo.orderId = ''
    },
    uploadBegin(event, file, fileList) {
      this.isUpload = false
      loading = this.$loading({
        lock: true,
        text: '正在识别图片',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 获取价格
    getPrice() {
      if (this.minute < 60) {
        this.$message.error('距离开场时间不足60分钟，无法下单')
        return;
      }
      if (this.isUpload) {
        return
      } else {
        loading = this.$loading({
          lock: true,
          text: '下单中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.movieInfo.isAllowChangeSeats = this.isAllowChangeSeats
        PayM.getPriceTb(this.movieInfo).then(res => {
          loading.close();
          if (res.data.code === 200) {
            this.orderInfo = res.data.data
            // this.$message.success('订单创建成功')
            this.dialogVisible = true
            this.isUpload = true
          } else {
            this.$message.error(res.data.message)
          }
        })
      }

    },
    handleSelect(item) {
      console.log("debug:________________handleSelect______________", item);
    },
    querySearchAsync(queryString, cb) {
      let params = {
        sign: 'shouto_movie_888',
        keyword: queryString,
        city: this.movieInfo.city
      }
      PayM.getCinema(params).then(result => {
        let res = result.data
        if (res.code === 200) {
          cb(res.data)
        } else {
          this.$message.error(res.message)
        }
      })
      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //   cb(results);
      // }, 3000 * Math.random());
    },
    handleClose(){
      this.dialogVisible = false
    },
    getOpeningTime(){
      let time, showTime
      showTime = this.movieInfo.showTime
      time = this.formatTime(new Date())
      let hour = this.GetDateDiff(time, showTime, 'minute') / 60
      let minute = this.GetDateDiff(time, showTime, 'minute')
      let timeArr = hour.toFixed(2).split('.')
      this.minute = minute
      this.openingTime = timeArr[0] + '小时' + (timeArr[1] * 60 / 100).toFixed(0) + '分钟'
    }
  }
}
</script>

<style scoped lang="less">
.content {
  padding: 16px;

  .center {
    background: #fff;
    padding: 16px;
    width: 80%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    min-width: 1250px;

    .title {
      font-size: 18px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 700;
      color: #222222;
      line-height: 27px;
      //text-align: center;
    }

    .upload {
      .upload-demo {
        //text-align: center;
      }

      .upload-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #222222;
        line-height: 20px;

        span {
          color: #18BC9C;
        }
      }
    }

    .message {
      background: #F8F9FB;
      border-radius: 4px;
      width: 840px;
      //height: 336px;
      //margin: auto;
      margin-top: 30px;
      padding: 30px;

    }
  }
}

.message-flex {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .message-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
    width: 100px;
    text-align: right;
  }

  .message-content {
    width: 680px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
    margin-left: 20px;
  }

  .message-span {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 20px;
    margin-left: 20px;

    span {
      width: 32px;
      height: 18px;
      border-radius: 2px;
      border: 1px solid #3D9EFC;
      font-size: 12px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #3D9EFC;
      line-height: 18px;
      cursor: pointer;
      padding: 0 4px;
      margin-left: 12px;
    }
  }

  .copyButton {
    width: 34px;
    height: 18px;
    border-radius: 2px;
    border: 1px solid #3D9EFC;
    font-size: 12px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #3D9EFC;
    line-height: 18px;
    cursor: pointer;
    padding: 0 4px;
    margin-left: 12px;
  }

  .input {
    width: 360px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #E8E8E8;
    margin-left: 20px;
    padding: 7px 16px;
  }
}
.button {
  width: 150px;
  height: 44px;
  background: #FF9934;
  margin: auto;
  margin-top: 20px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}

.image {
  width: 349px;
  height: 736px;

  img {
    width: 349px;
    height: 736px;
  }

  .image-div {
    width: 349px;
    height: 736px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e5e5e5;
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
<style scoped lang="less">
/deep/ .el-upload-dragger {
  width: 840px !important;
  height: 240px !important;
  /*margin: auto;*/
  margin-top: 20px;
}

.el-icon-upload {
  margin: 70px 0 16px !important;
}

.active-button {
  background: #e5e5e5 !important;
}
.colorRed{
  color: red!important;
  margin-left: 10px!important;
}
/deep/ .el-input__inner {
  width: 360px !important;
  height: 34px !important;
  background: #FFFFFF !important;
  border-radius: 2px !important;
  border: 1px solid #E8E8E8 !important;
  margin-left: 20px !important;
  padding: 7px 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/orderSearch/index.vue